// Render privacy policy
import React from "react";

const PrivacyPolicy = (props) => {
  return (
    <div className="component-privacy-policy">
      <h3>Privacy policy</h3>
      <div className="privacy-policy-details">
        <p>
          This Privacy Policy covers the collection, use, and disclosure of
          "personal information" by The Long Now Foundation, a California
          501-C(3) non profit corporation located at Fort Mason Center, 2 Marina
          Blvd, Bldg A, San Francisco, CA 94123-1284 and through the websites
          The Long Now Foundation operates: longnow.org, rosettaproject.org and
          longbets.org.
        </p>
        <p>
          Personal information is collected at several locations on our
          Websites; when you sign up for our email lists, join the Discussion
          Boards, become a member of or donate to The Long Now Foundation and if
          you purchase items from our online store.
        </p>
        <p>
          We may use the personal information you provide to us to respond to
          your requests for information or services or to send you
          communications about The Long Now Foundation.
        </p>
        <p>
          Personal information submitted as part of our Discussion Boards may be
          used for the purpose of managing the discussion lists. Your name and
          email address will typically be visible to other list participants
          when you correspond on the list and to the general public in the
          discussion archives.
        </p>
        <p>
          If you purchase merchandise directly from The Long Now Foundation, we
          may use your personal information for the purpose of sending you the
          items you purchased.
        </p>
        <p>
          You may join as a member, or donate money to The Long Now Foundation
          through our website, by mail or in our physical location at Fort
          Mason. We may use your personal information to process your donations
          and membership.
        </p>
        <p>
          However you give to The Long Now Foundation, participate in online
          discussions, or purchase merchandise, we additionally may use the
          personal information you provide to contact you about upcoming news
          and events relevant to The Long Now Foundation and to track your
          interactions with us. We will make every effort to provide an easily
          accessible way to edit your personal information or unsubscribe from
          these services.
        </p>
        <p>
          When you use our web sites, our servers (which may be hosted by a
          third party service provider) may collect information indirectly and
          automatically (through, for example, the use of your "IP address")
          about your activities while visiting the Websites, including the web
          pages you view and the times you view them and information about the
          browser you are using. We do not link browsing information to the
          personal information you submit to us; we may use this browsing
          information for internal purposes such as to help understand how the
          Websites are being used and to improve them, and for systems
          administration purposes. An IP address is a number that is
          automatically assigned to your computer when you use the Internet. In
          some cases your IP address stays the same from browser session to
          browser session; but if you use a consumer Internet access provider,
          your IP address probably varies from session to session.
        </p>
        <p>
          Although it is not The Long Now Foundation's practice to disclose
          personal information to third parties, we may share personal
          information in instances such as the following.
        </p>
        <p>
          The Long Now Foundation may share personal information with our
          contractors and service providers in order to maintain, enhance, or
          add to the functionality of our web sites. Secondly, we may share
          personal information with third parties such as the government or
          other entities when required to by law or as required by court order.
        </p>
        <p>
          The Long Now Foundation has implemented reasonable measures to protect
          against unauthorized access to and unlawful interception or processing
          of personal information that The Long Now Foundation stores and
          controls. However, no web site can fully eliminate security risks.
          Third parties may circumvent our security measures to unlawfully
          intercept or access transmissions or private communications. We will
          post a reasonably prominent notice to the Websites if any such
          security breach occurs.
        </p>
        <p>
          If you have questions about this Privacy Policy, please contact us by
          email at services@longnow.org.
        </p>
        <p>
          We hope this policy clarifies our procedures regarding your personal
          information. The Long Now Foundation may revise this policy at any
          time by updating this posting.
        </p>
        <p>Policy Established, October 1, 02006</p>
      </div>
    </div>
  );
};
export default PrivacyPolicy;
